import { useMutation } from '@tanstack/react-query';
import { DeleteCanceledFiles } from '../../../api/SecureFileUploader';

/**
 * Custom hook for deleting canceled files
 * @param {Function} onSuccessCallback - Optional callback after successful deletion
 * @param {Function} onErrorCallback - Optional callback after error
 * @returns {Object} - React Query mutation object
 */
export const useDeleteCanceledFiles = (onSuccessCallback, onErrorCallback) => {
  return useMutation({
    mutationFn: (guid) => DeleteCanceledFiles({ guid })(),
    onSuccess: (res) => {
      const message = res?.Message || res?.message || 'Upload canceled';

      if (onSuccessCallback) {
        onSuccessCallback(message, res);
      }
    },
    onError: (error) => {
      const errorMessage = error.message || 'An error occurred while deleting files';

      if (onErrorCallback) {
        onErrorCallback(errorMessage, error);
      }
    },
  });
};
